import React, { useEffect } from "react";
import ProgressChart from "../Components/Charts/ProgressChart";
import { Row, Col } from "antd";
import {
  BasicInformation,
  EducationalInformation,
  ProfessionalInformation,
  RightArrow,
  DotBall,
} from "../utils/icons";
import { useDispatch, useSelector } from "react-redux";
import { getUserBasicInfo } from "../slices/userSlice";
import { useNavigate } from "react-router-dom";

const Card = ({ title, heading, btn }) => {
  const splitText = heading.split("/");
  return (
    <div className="p-5 space-y-10 text-center rounded-3xl shadow-[0px_4px_18px_0px_#4B465C1A]">
      <h1 className="font-semibold text-[20px]">{title}</h1>
      {heading === "Complete" ? (
        <div className="py-[7px] flex gap-2 items-center justify-center">
          <DotBall />
          <p className="text-[#52B070]">{heading} </p>
        </div>
      ) : heading === "Not Started" ? (
        <div className="py-[7px] flex gap-2 items-center justify-center">
          <DotBall color="#DADADA" />
          <p className="text-MeduimGrey">{heading} </p>
        </div>
      ) : (
        <h1 className="font-semibold text-2xl text-MeduimGrey">
          <span className="text-orange1">{`${splitText[0]}`}</span>{" "}
          {`/ ${splitText[1]}`}
        </h1>
      )}
      <button
        className={`${
          heading === "Complete" ? "bg-MeduimGrey" : "bg-sandAgainBtn"
        } px-5 py-1 text-base rounded-3xl text-pureWhite`}
      >
        {btn}
      </button>
    </div>
  );
};

const TextBox = ({ icon, title, btn, navigate }) => {
  console.log("🚀 ~ TextBox ~ navigate:", navigate);
  const navigation = useNavigate();

  const handleNavigate = () => {
    if (typeof navigate === "string") {
      // If navigate is just a string path
      navigation(navigate);
    } else if (
      typeof navigate === "object" &&
      navigate.path &&
      navigate.state
    ) {
      // If navigate is an object with path and state
      navigation(navigate.path, { state: navigate.state });
    }
  };
  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-5">
        {icon}
        <h1 className="font-semibold">{title}</h1>
      </div>
      <button
        onClick={handleNavigate}
        className="flex items-center gap-2 text-sm text-DarkGrey"
      >
        {btn}
        <RightArrow />
      </button>
    </div>
  );
};

function ThingsToDo() {
  const userBasicInfo = useSelector((state) => state.user.userBasicInfo) || [];
  console.log(userBasicInfo, " = userBasicInfouserBasicInfo");
  const { IsBasicInfoAdd, IsEducationalInfoAdd, IsProfessionalInfoAdd } =
    userBasicInfo;
  let totalPercentage = 0;
  if (IsBasicInfoAdd) totalPercentage += 30;
  if (IsEducationalInfoAdd) totalPercentage += 35;
  if (IsProfessionalInfoAdd) totalPercentage += 35;
  return (
    <div className="p-5 bg-pureWhite rounded-3xl mt-5 space-y-5">
      <h1 className="font-semibold text-lg">ThingsToDo</h1>
      <Row gutter={[10, 10]}>
        <Col span={12}>
          <ProgressChart totalPercentage={totalPercentage} height={300} />
          <div className="w-[95%] m-auto space-y-5 flex flex-col">
            <TextBox
              icon={<BasicInformation />}
              title="Basic Information"
              btn="Update Details"
              navigate={{ path: "/portfolio", state: { tab: 1 } }}
            />
            <TextBox
              icon={<EducationalInformation />}
              title="Educational Information"
              btn="Complete Details"
              navigate={{ path: "/portfolio", state: { tab: 2 } }}
            />
            <TextBox
              icon={<ProfessionalInformation />}
              title="Professional Information"
              btn="Complete Details"
              navigate={{ path: "/portfolio", state: { tab: 3 } }}
            />
            <button className="rounded-3xl bg-sandAgainBtn text-pureWhite w-60 p-2 text-base self-center">
              Complete
            </button>
          </div>
        </Col>
        <Col span={12}>
          <Row gutter={[10, 10]}>
            <Col span={12}>
              <Card
                title="Attend Orientation"
                heading="Complete"
                btn="Attend"
              />
            </Col>
            <Col span={12}>
              <Card title="Required Documents" heading="1/5" btn="complete" />
            </Col>
            <Col span={12}>
              <Card title="Set IEP" heading="Not Started" btn="Start" />
            </Col>
            <Col span={12}>
              <Card title="360 Assessments" heading="1/360" btn="complete " />
            </Col>
          </Row>
        </Col>
        <Col span={16}>
          <Card title="Join Challenges" heading="0/10" btn="Join" />
        </Col>
        <Col span={8}>
          <Card title="Compulsory Courses" heading="3/10" btn="complete " />
        </Col>
      </Row>
    </div>
  );
}

export default ThingsToDo;
